import { getFirstLocationFromSensors } from '@Actions';
import { getValue } from '@Selectors';
import { SensorGroupConfigs } from '@Types/sensorGroup.types';
import { LiftStationFormFields } from '@Types/stations.types';
import { parseLocationToString } from '@Utils/parseLocation';
import { useFormikContext } from 'formik';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function useGetLocationsFromSensorsInFormik() {
	const { values, setFieldValue } = useFormikContext<LiftStationFormFields>();
	const { sensorGroups } = useSelector(getValue).sensorGroup.sensorGroups;
	const { stationLocation } = useSelector(getValue).stations;

	const dispatch = useDispatch();

	const fullSensorList = useMemo(() => {
		const sensorInSensorGroups =
			(values?.sensorGroups
				?.map(id => {
					const fullSensorGroup = sensorGroups.find(
						(s: SensorGroupConfigs) => s._id === id,
					);
					return fullSensorGroup?.sensorGroupPairs?.[0]?.sensorId;
				})
				.filter(sensorId => sensorId) as string[]) || [];
		return [...(values?.sensors || []), ...sensorInSensorGroups];
	}, [values.sensors, values.sensorGroups, sensorGroups]);

	useEffect(() => {
		if (stationLocation && values.location?.trim() === '') {
			const locationString = parseLocationToString(stationLocation);
			setFieldValue('location', locationString);
		}
	}, [stationLocation]);

	useEffect(() => {
		dispatch(getFirstLocationFromSensors(fullSensorList));
	}, [fullSensorList]);
}
